import { CardElement } from "@stripe/react-stripe-js";
import React, { useRef } from "react";
import styled from "styled-components";
import { ItemLabel, ItemTitle } from "sweet-web/components/universal/Text";
import { colors } from "sweet-web/lib/styles";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  transition: all 100ms cubic-bezier(0.21, 0.94, 0.64, 0.99);
  width: 100%;
  margin: 5px 0;
`;

type OwnProps = {
  style?: object;
  title?: string;
  description?: string;
  name?: string;
};
type Props = OwnProps;
const CardInput: React.FC<Props> = props => {
  const { title, description, style } = props;

  return (
    <Wrapper style={style}>
      {title && <ItemTitle>{title}</ItemTitle>}
      {description && <ItemLabel>{description}</ItemLabel>}
      <CardElement className="SweetCardElement" />
      <style>
        {`
        .SweetCardElement {
          height: 40px;
          padding: 10px 12px;
          width: 100%;
          color: ${colors.nearBlack};
          background-color: white;
          border: 1px solid ${colors.lightGray};
          border-radius: 5px;
          transition: box-shadow 100ms ease;
        }

        .SweetCardElement--focus {
          box-shadow: 0 1px 3px 0 #cfd7df;
        }

        .SweetCardElement--invalid {
          border-color: #fa755a;
        }

        .SweetCardElement--webkit-autofill {
          background-color: #fefde5 !important;
        }
        `}
      </style>
    </Wrapper>
  );
};
CardInput.defaultProps = {
  style: {}
};

export default CardInput;
